import { z } from 'zod';
/**
 * E8 — indicadores que emergem dos estados do processo (RF-38/RF-39).
 *
 * O criterio de saida do R1 no PRD e "MKBF publicado automaticamente". Ele nao
 * e digitado em lugar nenhum: sai da quilometragem rodada dividida pelos
 * retornos nao programados, ambos ja registrados pelo proprio fluxo.
 */
export const metricsQuerySchema = z.object({
    from: z.coerce.date().optional(),
    to: z.coerce.date().optional(),
});
/** Chaves dos snapshots mensais (E8). Espelha o enum do banco. */
export const MetricKey = {
    MKBF: 'MKBF',
    FLEET_AVAILABILITY: 'FLEET_AVAILABILITY',
    DOWNTIME_BY_CAUSE: 'DOWNTIME_BY_CAUSE',
    FIELD_RESOLUTION: 'FIELD_RESOLUTION',
    PREVENTIVE_ADHERENCE: 'PREVENTIVE_ADHERENCE',
    INTERNAL_REWORK: 'INTERNAL_REWORK',
    ADOPTION: 'ADOPTION',
    TRIAGE_SLA: 'TRIAGE_SLA',
};
export const METRIC_KEY_LABELS = {
    MKBF: 'MKBF (km)',
    FLEET_AVAILABILITY: 'Disponibilidade da frota',
    DOWNTIME_BY_CAUSE: 'Indisponibilidade (min)',
    FIELD_RESOLUTION: 'Resolução em campo',
    PREVENTIVE_ADHERENCE: 'Aderência à preventiva',
    INTERNAL_REWORK: 'Retrabalho interno',
    ADOPTION: 'Adoção do processo',
    TRIAGE_SLA: 'SLA de triagem (mediana, s)',
};
export const metricsHistoryQuerySchema = z.object({
    months: z.coerce.number().int().min(1).max(36).default(12),
});
//# sourceMappingURL=metrics.schemas.js.map